export * from './TrapezoidTabs';
